// extracted by css-extract-rspack-plugin
export default {"root":"knVRyn","item":"ivUHKZ"};